export const roundToTwoDigits = (num: number, compactThreshold = 1000000): string => {
  const shouldUseCompactNotation = num >= compactThreshold;

  return new Intl.NumberFormat(undefined, {
    notation: shouldUseCompactNotation ? "compact" : "standard",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    trailingZeroDisplay: "stripIfInteger",
  })
    .format(num)
    .toLowerCase();
};
